import React from "react";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
const unsupportedImg = "/assets/images/NoImagePlaceholder.png";

const getExtensionFromFileName = (fileName: string): string => {
  const cleanName = fileName.split("?")[0];
  const lastDotIndex = cleanName.lastIndexOf(".");
  if (lastDotIndex === -1) return "";
  return cleanName.substring(lastDotIndex + 1).toLowerCase();
};

const getExtension = (pathStr: string): string => {
  if (!pathStr) return "";
  try {
    if (pathStr.includes("?")) {
      const searchParams = new URLSearchParams(pathStr.split("?")[1]);
      const objectPath = searchParams.get("objectPath");
      if (objectPath) {
        return getExtensionFromFileName(objectPath);
      }
    }
  } catch (e) {
    // Ignore parsing errors
  }
  return getExtensionFromFileName(pathStr);
};

const ImageLoader = ({
  path,
  findImg,
  index,
  className,
  notFoundImg,
  styleObject,
  onLoadComplete = null,
  imgId,
}: any) => {
  const isSupported = (pathStr: string) => {
    if (!pathStr) return false;
    const ext = getExtension(pathStr);
    return ["jpg", "jpeg", "gif", "png", "ico"].includes(ext);
  };

  const getInitialSrc = () => {
    if (!path) return notFoundImg || "";
    if (!isSupported(path)) return unsupportedImg;
    return path;
  };

  const [src, setSrc] = useState(getInitialSrc);
  console.log("path :", path);
  const [isLoading, setIsLoading] = useState(false);
  const [requestCounter, setRequestCounter] = useState(0);
  const [classStyle, setClassStyle] = useState(className || "img-fluid");
  const api = useAxiosPrivate();
  const successImage = (res: any) => {
    setSrc(res);
  };
  const errorCallback = (err: any) => {
    setSrc("");
  };
  const loadImage = async () => {
    if (path) {
      var qParam: string = path;
      const res = await api.get(
        `/api/session/downloadUrl?objectPath=${qParam}`,
      );
      setSrc(res.data);
      if (onLoadComplete) {
        onLoadComplete(res.data, imgId);
      }
      setTimeout(() => {
        setIsLoading(false);
      });
    } else {
      setSrc(notFoundImg || "");
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (path) {
      if (!isSupported(path)) {
        setSrc(unsupportedImg);
        setIsLoading(false);
        if (onLoadComplete) {
          onLoadComplete(unsupportedImg, imgId);
        }
      } else {
        setIsLoading(true);
        loadImage();
      }
    } else {
      setSrc(notFoundImg || "");
      setIsLoading(false);
    }
  }, [path]);

  return (
    <div className="text-center">
      {isLoading ? (
        <div style={{ paddingTop: "40px" }}>
          {" "}
          <i className="fa fa-spinner" style={{ fontSize: "25px" }}></i>
        </div>
      ) : (
        <img
          src={src}
          alt={"not found"}
          onClick={() => {
            if (findImg) findImg(index);
          }}
          className={classStyle}
          style={styleObject || { maxHeight: "300px" }}
          onError={(e: any) => {
            // e.target.src = src;
            if (requestCounter < 1) {
              loadImage();
              setRequestCounter(requestCounter + 1);
            }
          }}
        />
      )}
    </div>
  );
};

export default ImageLoader;
